var map = {
	"./ei_transfers_icon.svg": 1122,
	"./mainNavigationChevron_icon.svg": 1123,
	"./schedule_icon.svg": 1124,
	"./sports-news_icon.svg": 1125,
	"./sports_icon.svg": 1126,
	"./table_icon.svg": 1127,
	"./transfers_icon.svg": 1128,
	"./worldnews_icon.svg": 1129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1351;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1351
// module chunks = 35